<template>
	<b-col cols="6">
		<h4 class="mt-3">Wealth</h4>
		<b-table-simple responsive small bordered striped table-class="mb-0">
			<b-tbody>
				<b-tr>
					<b-td><strong>Credits</strong></b-td>
					<b-td class="text-right">{{Character.Equipment.Credits}}</b-td>
				</b-tr>
				<b-tr>
					<b-td><strong>Total Wealth</strong></b-td>
					<b-td class="text-right">{{calcWealth}}</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-col>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters('character/equipment',[
			'calcWealth',
		]),
	}
}
</script>

<style scoped>

</style>